import * as React from "react";
import Text from "antd/lib/typography/Text";

const FIRST_ERROR = 0;

const ErrorMessage = ({
  errors,
  showAllErrors = false
}: {
  errors: string[];
  showAllErrors?: boolean;
}) => {
  return (
    <Text className={"label-error"}>
      {showAllErrors ? errors : errors[FIRST_ERROR]}
    </Text>
  );
};
export default ErrorMessage;
